import { render } from "./PmoCategoryTags.vue?vue&type=template&id=5a9365e4"
import script from "./PmoCategoryTags.vue?vue&type=script&setup=true&lang=js"
export * from "./PmoCategoryTags.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-categorization-drag-drop/components/filter/PmoCategoryTags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a9365e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a9365e4', __exports__)) {
    api.reload('5a9365e4', __exports__)
  }
  
  module.hot.accept("./PmoCategoryTags.vue?vue&type=template&id=5a9365e4", () => {
    api.rerender('5a9365e4', render)
  })

}


export default __exports__